var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g(_vm._b({staticClass:"c-dropdown-button"},'button',_vm.attrs,false),_vm.listeners),[_vm._t("default",null,null,_vm.slotBindings)],2)}
var staticRenderFns = []

export { render, staticRenderFns }